//version 20230420
const countriesData = [
  {
    "code": "355",
    "en": "AFGHANISTAN",
    "pt": "AFEGANISTÃO",
    "zh": "阿富汗",
    "icao": "AFG"
  },
  {
    "code": "020",
    "en": "ALBANIA",
    "pt": "ALBANIA",
    "zh": "阿爾巴尼亞",
    "icao": "ALB"
  },
  {
    "code": "054",
    "en": "ALGERIA",
    "pt": "ARGELIA",
    "zh": "阿爾及利亞",
    "icao": "DZA"
  },
  {
    "code": "030",
    "en": "ANDORRA",
    "pt": "ANDORRA",
    "zh": "安道爾",
    "icao": "AND"
  },
  {
    "code": "053",
    "en": "ANGOLA",
    "pt": "REP. POPULAR DE ANGOLA",
    "zh": "安哥拉",
    "icao": "AGO"
  },
  {
    "code": "223",
    "en": "ANTIGUA AND BARBUDA",
    "pt": "ANTIGUA E BARBUDA",
    "zh": "安提瓜和巴布達",
    "icao": "ATG"
  },
  {
    "code": "150",
    "en": "ARGENTINA",
    "pt": "ARGENTINA",
    "zh": "阿根廷",
    "icao": "ARG"
  },
  {
    "code": "514",
    "en": "ARMENIA",
    "pt": "REPUBLICA DA ARMÉNIA",
    "zh": "亞美尼亞",
    "icao": "ARM"
  },
  {
    "code": "400",
    "en": "AUSTRALIA",
    "pt": "AUSTRALIA",
    "zh": "澳大利亞",
    "icao": "AUS"
  },
  {
    "code": "011",
    "en": "AUSTRIA",
    "pt": "AUSTRIA",
    "zh": "奧地利",
    "icao": "AUT"
  },
  {
    "code": "523",
    "en": "AZERBAIJAN",
    "pt": "REPUBLICA DO ADZERBAIJÃO",
    "zh": "亞塞拜彊",
    "icao": "AZE"
  },
  {
    "code": "201",
    "en": "BAHAMAS",
    "pt": "BAHAMAS",
    "zh": "巴哈馬",
    "icao": "BHS"
  },
  {
    "code": "301",
    "en": "BAHRAIN",
    "pt": "BAHRAIN",
    "zh": "巴林",
    "icao": "BHR"
  },
  {
    "code": "250",
    "en": "BANGLADESH",
    "pt": "BANGLADESH",
    "zh": "孟加拉國",
    "icao": "BGD"
  },
  {
    "code": "202",
    "en": "BARBADOS",
    "pt": "BARBADOS",
    "zh": "巴巴多斯",
    "icao": "BRB"
  },
  {
    "code": "502",
    "en": "BELGIUM",
    "pt": "BELGICA",
    "zh": "比利時",
    "icao": "BEL"
  },
  {
    "code": "203",
    "en": "BELIZE",
    "pt": "BELIZE",
    "zh": "伯利茲",
    "icao": "BLZ"
  },
  {
    "code": "204",
    "en": "BERMUDA",
    "pt": "BERMUDAS",
    "zh": "百慕逹",
    "icao": "BMU"
  },
  {
    "code": "253",
    "en": "BHUTAN",
    "pt": "BUTÃO",
    "zh": "不丹",
    "icao": "BTN"
  },
  {
    "code": "151",
    "en": "BOLIVIA",
    "pt": "BOLIVIA",
    "zh": "玻利維亞",
    "icao": "BOL"
  },
  {
    "code": "522",
    "en": "BOSNIA AND HERZEGOVINA",
    "pt": "REP. BOSNIA HERZEGOVINA",
    "zh": "波斯尼亞及黑塞哥維那",
    "icao": "BES"
  },
  {
    "code": "056",
    "en": "BOTSWANA",
    "pt": "BOTSWANA",
    "zh": "博茨瓦納",
    "icao": "BWA"
  },
  {
    "code": "152",
    "en": "BRAZIL",
    "pt": "BRASIL",
    "zh": "巴西",
    "icao": "BRA"
  },
  {
    "code": "252",
    "en": "BRUNEI",
    "pt": "BRUNEI",
    "zh": "文萊",
    "icao": "BRN"
  },
  {
    "code": "022",
    "en": "BULGARIA",
    "pt": "BULGARIA",
    "zh": "保加利亞",
    "icao": "BGR"
  },
  {
    "code": "052",
    "en": "BURKINA FASO",
    "pt": "BURKINA FASO",
    "zh": "布基納法索",
    "icao": "BFA"
  },
  {
    "code": "057",
    "en": "BURUNDI",
    "pt": "BURUNDI",
    "zh": "布隆迪",
    "icao": "BDI"
  },
  {
    "code": "254",
    "en": "CAMBODIA",
    "pt": "CAMBOJA",
    "zh": "柬埔寨",
    "icao": "KHM"
  },
  {
    "code": "059",
    "en": "CAMEROON",
    "pt": "CAMARÕES",
    "zh": "喀麥隆",
    "icao": "CMR"
  },
  {
    "code": "205",
    "en": "CANADA",
    "pt": "CANADA",
    "zh": "加拿大",
    "icao": "CAN"
  },
  {
    "code": "058",
    "en": "CAPE VERDE, REP.",
    "pt": "REP. DE CABO VERDE",
    "zh": "佛得角",
    "icao": "CPV"
  },
  {
    "code": "086",
    "en": "CENTRAL AFRICAN REPUBLIC",
    "pt": "REPUBLICA CENTRO-AFRICANA",
    "zh": "中非",
    "icao": "CAF"
  },
  {
    "code": "099",
    "en": "CHAD",
    "pt": "CHADE",
    "zh": "乍得",
    "icao": "TCD"
  },
  {
    "code": "153",
    "en": "CHILE",
    "pt": "CHILE",
    "zh": "智利",
    "icao": "CHL"
  },
  {
    "code": "154",
    "en": "COLOMBIA",
    "pt": "COLOMBIA",
    "zh": "哥倫比亞",
    "icao": "COL"
  },
  {
    "code": "173",
    "en": "COMMONWEALTH OF DOMINICA",
    "pt": "COMMONWEALTH DE LA DOMINI",
    "zh": "多米尼克",
    "icao": "DMA"
  },
  {
    "code": "062",
    "en": "CONGO",
    "pt": "REP. POPULAR DO CONGO",
    "zh": "剛果(布)",
    "icao": "COG"
  },
  {
    "code": "155",
    "en": "COSTA RICA",
    "pt": "COSTA RICA",
    "zh": "哥斯達黎加",
    "icao": "CRI"
  },
  {
    "code": "521",
    "en": "CROATIA",
    "pt": "CROACIA",
    "zh": "克羅地亞",
    "icao": "HRV"
  },
  {
    "code": "156",
    "en": "CUBA",
    "pt": "CUBA",
    "zh": "古巴",
    "icao": "CUB"
  },
  {
    "code": "302",
    "en": "CYPRUS",
    "pt": "CHIPRE",
    "zh": "塞浦路斯",
    "icao": "CYP"
  },
  {
    "code": "023",
    "en": "CZECH REPUBLIC",
    "pt": "REPUBLICA DA CHECA",
    "zh": "捷克",
    "icao": "CZE"
  },
  {
    "code": "351",
    "en": "D.P.R. OF KOREA",
    "pt": "REP.DEM.POP. DA COREIA",
    "zh": "朝鮮",
    "icao": "PRK"
  },
  {
    "code": "104",
    "en": "DEMOCRATIC REP. OF CONGO",
    "pt": "REP. DEMOCRATICA DO CONGO",
    "zh": "剛果(金)",
    "icao": "COD"
  },
  {
    "code": "503",
    "en": "DENMARK",
    "pt": "DINAMARCA",
    "zh": "丹麥",
    "icao": "DNK"
  },
  {
    "code": "050",
    "en": "DJIBOUTI",
    "pt": "DIJIBUTI",
    "zh": "吉布提",
    "icao": "DJI"
  },
  {
    "code": "167",
    "en": "DOMINICAN REP.",
    "pt": "REPUBLICA DOMINICANA",
    "zh": "多米尼加",
    "icao": "DOM"
  },
  {
    "code": "269",
    "en": "EAST TIMOR",
    "pt": "TIMOR",
    "zh": "東帝汶",
    "icao": "TLS"
  },
  {
    "code": "157",
    "en": "ECUADOR",
    "pt": "EQUADOR",
    "zh": "厄瓜多爾",
    "icao": "ECU"
  },
  {
    "code": "064",
    "en": "EGYPT",
    "pt": "REP. ARABE DO EGIPTO",
    "zh": "埃及",
    "icao": "EGY"
  },
  {
    "code": "168",
    "en": "EL SALVADOR",
    "pt": "REPUBLICA DE EL SALVADOR",
    "zh": "薩爾瓦多",
    "icao": "SLV"
  },
  {
    "code": "070",
    "en": "EQUATORIAL GUINEA",
    "pt": "REP. DA GUINE EQUATORIAL",
    "zh": "赤道畿內亞",
    "icao": "GNQ"
  },
  {
    "code": "511",
    "en": "ESTONIA",
    "pt": "REPUBLICA DA ESTÓNIA",
    "zh": "愛沙尼亞",
    "icao": "EST"
  },
  {
    "code": "065",
    "en": "ETHIOPIA",
    "pt": "ETIOPIA",
    "zh": "埃塞俄比亞",
    "icao": "ETH"
  },
  {
    "code": "402",
    "en": "FIJI",
    "pt": "FIJI",
    "zh": "斐濟",
    "icao": "FJI"
  },
  {
    "code": "012",
    "en": "FINLAND",
    "pt": "FINLANDIA",
    "zh": "芬蘭",
    "icao": "FIN"
  },
  {
    "code": "504",
    "en": "FRANCE",
    "pt": "FRANÇA",
    "zh": "法國",
    "icao": "FRA"
  },
  {
    "code": "066",
    "en": "GABON",
    "pt": "REPUBLICA GABONESA",
    "zh": "加蓬",
    "icao": "GAB"
  },
  {
    "code": "067",
    "en": "GAMBIA",
    "pt": "REP. DA GAMBIA",
    "zh": "岡比亞",
    "icao": "GMB"
  },
  {
    "code": "520",
    "en": "GEORGIA",
    "pt": "REPUBLICA DA GEORGIA",
    "zh": "格魯吉亞",
    "icao": "GEO"
  },
  {
    "code": "501",
    "en": "GERMANY",
    "pt": "REP. FEDERAL DA ALEMANHA",
    "zh": "德國",
    "icao": "DEU"
  },
  {
    "code": "068",
    "en": "GHANA",
    "pt": "GANA",
    "zh": "加納",
    "icao": "GHA"
  },
  {
    "code": "009",
    "en": "GREECE",
    "pt": "GRECIA",
    "zh": "希臘",
    "icao": "GRC"
  },
  {
    "code": "158",
    "en": "GRENADA",
    "pt": "GRANADA",
    "zh": "格林納達",
    "icao": "GRD"
  },
  {
    "code": "159",
    "en": "GUATEMALA",
    "pt": "GUATEMALA",
    "zh": "危地馬拉",
    "icao": "GTM"
  },
  {
    "code": "069",
    "en": "GUINEA-BISSAU",
    "pt": "REP. DA GUINE-BISSAU",
    "zh": "幾內亞比紹",
    "icao": "GNB"
  },
  {
    "code": "211",
    "en": "GUYANA",
    "pt": "REP. DA GUIANA",
    "zh": "圭亞那",
    "icao": "GUY"
  },
  {
    "code": "160",
    "en": "HAITI",
    "pt": "HAITI",
    "zh": "海地",
    "icao": "HTI"
  },
  {
    "code": "161",
    "en": "HONDURAS",
    "pt": "HONDURAS",
    "zh": "洪都拉斯",
    "icao": "HND"
  },
  {
    "code": "258",
    "en": "HONG KONG",
    "pt": "HONG-KONG",
    "zh": "香港",
    "icao": "HKG"
  },
  {
    "code": "024",
    "en": "HUNGARY",
    "pt": "HUNGRIA",
    "zh": "匈牙利",
    "icao": "HUN"
  },
  {
    "code": "013",
    "en": "ICELAND",
    "pt": "ISLANDIA",
    "zh": "冰島",
    "icao": "ISL"
  },
  {
    "code": "259",
    "en": "INDIA",
    "pt": "REPUBLICA DA INDIA",
    "zh": "印度",
    "icao": "IND"
  },
  {
    "code": "260",
    "en": "INDONESIA",
    "pt": "INDONESIA",
    "zh": "印度尼西亞",
    "icao": "IDN"
  },
  {
    "code": "304",
    "en": "IRAN",
    "pt": "IRÃO",
    "zh": "伊朗",
    "icao": "IRN"
  },
  {
    "code": "305",
    "en": "IRAQ",
    "pt": "IRAQUE",
    "zh": "伊拉克",
    "icao": "IRQ"
  },
  {
    "code": "506",
    "en": "IRELAND",
    "pt": "IRLANDA",
    "zh": "愛爾蘭",
    "icao": "IRL"
  },
  {
    "code": "306",
    "en": "ISRAEL",
    "pt": "ISRAEL",
    "zh": "以色列",
    "icao": "ISR"
  },
  {
    "code": "507",
    "en": "ITALY",
    "pt": "ITALIA",
    "zh": "意大利",
    "icao": "ITA"
  },
  {
    "code": "063",
    "en": "IVORY COAST",
    "pt": "COSTA DO MARFIM",
    "zh": "科特迪瓦",
    "icao": "CIV"
  },
  {
    "code": "214",
    "en": "JAMAICA",
    "pt": "JAMAICA",
    "zh": "牙買加",
    "icao": "JAM"
  },
  {
    "code": "261",
    "en": "JAPAN",
    "pt": "JAPÃO",
    "zh": "日本",
    "icao": "JPN"
  },
  {
    "code": "307",
    "en": "JORDAN",
    "pt": "JORDANIA",
    "zh": "約旦",
    "icao": "JOR"
  },
  {
    "code": "530",
    "en": "KAZAKHSTAN",
    "pt": "CAZAQUISTÃO",
    "zh": "哈薩克斯坦",
    "icao": "KAZ"
  },
  {
    "code": "085",
    "en": "KENYA",
    "pt": "QUENIA",
    "zh": "肯尼亞",
    "icao": "KEN"
  },
  {
    "code": "356",
    "en": "KIRIBATI",
    "pt": "KIRIBATI",
    "zh": "基里巴斯",
    "icao": "KIR"
  },
  {
    "code": "308",
    "en": "KUWAIT",
    "pt": "KUWAIT",
    "zh": "科威特",
    "icao": "KWT"
  },
  {
    "code": "524",
    "en": "KYRGYZSTAN",
    "pt": "REPUBLICA DO KIRISTÃO",
    "zh": "吉爾吉斯斯坦",
    "icao": "KGZ"
  },
  {
    "code": "354",
    "en": "LAOS",
    "pt": "LAOS",
    "zh": "老撾",
    "icao": "LAO"
  },
  {
    "code": "512",
    "en": "LATVIA",
    "pt": "REPUBLICA DA LETÓNIA",
    "zh": "拉脫維亞",
    "icao": "LVA"
  },
  {
    "code": "309",
    "en": "LEBANON",
    "pt": "LIBANO",
    "zh": "黎巴嫩",
    "icao": "LBN"
  },
  {
    "code": "072",
    "en": "LESOTHO",
    "pt": "LESOTHO",
    "zh": "萊索托",
    "icao": "LSO"
  },
  {
    "code": "073",
    "en": "LIBERIA",
    "pt": "LIBERIA",
    "zh": "利比里亞",
    "icao": "LBR"
  },
  {
    "code": "074",
    "en": "LIBYA",
    "pt": "LIBIA",
    "zh": "利比亞",
    "icao": "LBY"
  },
  {
    "code": "513",
    "en": "LITHUANIA",
    "pt": "REPUBLICA DA LITUÂNIA",
    "zh": "立陶宛",
    "icao": "LTU"
  },
  {
    "code": "010",
    "en": "LUXEMBOURG",
    "pt": "LUXEMBURGO",
    "zh": "盧森堡",
    "icao": "LUX"
  },
  {
    "code": "525",
    "en": "MACEDONIA",
    "pt": "REPUBLICA DA MACEDONIA",
    "zh": "馬其頓",
    "icao": "MKD"
  },
  {
    "code": "075",
    "en": "MADAGASCAR",
    "pt": "MADAGASCAR",
    "zh": "馬達加斯加",
    "icao": "MDG"
  },
  {
    "code": "076",
    "en": "MALAWI",
    "pt": "REPUBLICA DO MALAWI",
    "zh": "馬拉維",
    "icao": "MWI"
  },
  {
    "code": "262",
    "en": "MALAYSIA",
    "pt": "MALASIA",
    "zh": "馬來西亞",
    "icao": "MYS"
  },
  {
    "code": "263",
    "en": "MALDIVES",
    "pt": "MALDIVAS",
    "zh": "馬爾代夫",
    "icao": "MDV"
  },
  {
    "code": "077",
    "en": "MALI",
    "pt": "MALI",
    "zh": "馬里",
    "icao": "MLI"
  },
  {
    "code": "036",
    "en": "MALTA",
    "pt": "MALTA",
    "zh": "馬耳他",
    "icao": "MLT"
  },
  {
    "code": "401",
    "en": "MARSHALL ISLANDS",
    "pt": "ILHAS MARSHALL",
    "zh": "馬紹爾群島",
    "icao": "MHL"
  },
  {
    "code": "080",
    "en": "MAURITANIA",
    "pt": "MAURITANIA",
    "zh": "毛里塔尼亞",
    "icao": "MRT"
  },
  {
    "code": "079",
    "en": "MAURITIUS",
    "pt": "MAURICIA",
    "zh": "毛里求斯",
    "icao": "MUS"
  },
  {
    "code": "162",
    "en": "MEXICO",
    "pt": "MEXICO",
    "zh": "墨西哥",
    "icao": "MEX"
  },
  {
    "code": "529",
    "en": "MOLDOVA",
    "pt": "REPUBLICA DA MOLDAVIA",
    "zh": "摩爾多瓦",
    "icao": "MDA"
  },
  {
    "code": "045",
    "en": "MONACO",
    "pt": "MONACO",
    "zh": "摩納哥",
    "icao": "MCO"
  },
  {
    "code": "352",
    "en": "MONGOLIA",
    "pt": "MONGOLIA",
    "zh": "蒙古",
    "icao": "MNG"
  },
  {
    "code": "078",
    "en": "MOROCCO",
    "pt": "MARROCOS",
    "zh": "摩洛哥",
    "icao": "MAR"
  },
  {
    "code": "082",
    "en": "MOZAMBIQUE",
    "pt": "REP.POPULAR DE MOÇAMBIQUE",
    "zh": "莫桑比克",
    "icao": "MOZ"
  },
  {
    "code": "251",
    "en": "MYANMAR",
    "pt": "BIRMANIA",
    "zh": "緬甸",
    "icao": "MMR"
  },
  {
    "code": "107",
    "en": "NAMIBIA",
    "pt": "NAMIBIA",
    "zh": "納米比亞",
    "icao": "NAM"
  },
  {
    "code": "404",
    "en": "NAURU",
    "pt": "NAURU",
    "zh": "瑙魯",
    "icao": "NRU"
  },
  {
    "code": "264",
    "en": "NEPAL",
    "pt": "NEPAL",
    "zh": "尼泊爾",
    "icao": "NPL"
  },
  {
    "code": "505",
    "en": "NETHERLANDS",
    "pt": "HOLANDA",
    "zh": "荷蘭",
    "icao": "NLD"
  },
  {
    "code": "405",
    "en": "NEW CALEDONIA",
    "pt": "NOVA CALEDÓNIA",
    "zh": "新喀里多尼亞",
    "icao": "NCL"
  },
  {
    "code": "406",
    "en": "NEW ZEALAND",
    "pt": "NOVA ZELANDIA",
    "zh": "新西蘭",
    "icao": "NZL"
  },
  {
    "code": "163",
    "en": "NICARAGUA",
    "pt": "NICARAGUA",
    "zh": "尼加拉瓜",
    "icao": "NIC"
  },
  {
    "code": "083",
    "en": "NIGER",
    "pt": "NIGER",
    "zh": "尼日爾",
    "icao": "NER"
  },
  {
    "code": "084",
    "en": "NIGERIA",
    "pt": "NIGERIA",
    "zh": "尼日利亞",
    "icao": "NGA"
  },
  {
    "code": "014",
    "en": "NORWAY",
    "pt": "NORUEGA",
    "zh": "挪威",
    "icao": "NOR"
  },
  {
    "code": "265",
    "en": "PAKISTAN",
    "pt": "PAQUISTÃO",
    "zh": "巴基斯坦",
    "icao": "PAK"
  },
  {
    "code": "538",
    "en": "PALAU",
    "pt": "REPUBLICA DE PALAU",
    "zh": "帕勞",
    "icao": "PLW"
  },
  {
    "code": "537",
    "en": "PALESTINE",
    "pt": "PALESTINA",
    "zh": "巴勒斯坦",
    "icao": "PSE"
  },
  {
    "code": "164",
    "en": "PANAMA",
    "pt": "PANAMA",
    "zh": "巴拿馬",
    "icao": "PAN"
  },
  {
    "code": "408",
    "en": "PAPUA NEW GUINEA",
    "pt": "PAPUA NOVA GUINÉ",
    "zh": "巴布亞新畿內亞",
    "icao": "PNG"
  },
  {
    "code": "165",
    "en": "PARAGUAY",
    "pt": "PARAGUAI",
    "zh": "巴拉圭",
    "icao": "PRY"
  },
  {
    "code": "166",
    "en": "PERU",
    "pt": "PERU",
    "zh": "秘魯",
    "icao": "PER"
  },
  {
    "code": "257",
    "en": "PHILIPPINES",
    "pt": "FILIPINAS",
    "zh": "菲律賓",
    "icao": "PHL"
  },
  {
    "code": "025",
    "en": "POLAND",
    "pt": "POLONIA",
    "zh": "波蘭",
    "icao": "POL"
  },
  {
    "code": "017",
    "en": "PORTUGAL",
    "pt": "PORTUGAL",
    "zh": "葡萄牙",
    "icao": "PRT"
  },
  {
    "code": "040",
    "en": "PRINCIPALITY OF LIECHTENSTEIN",
    "pt": "LIECHTENSTEIN",
    "zh": "列支敦士登",
    "icao": "LIE"
  },
  {
    "code": "311",
    "en": "QATAR",
    "pt": "QUATAR / CATAR",
    "zh": "卡塔爾",
    "icao": "QAT"
  },
  {
    "code": "533",
    "en": "REPUBLIC OF BELARUS",
    "pt": "REPUBLICA DA BIELORUSSIA",
    "zh": "白俄羅斯",
    "icao": "BLR"
  },
  {
    "code": "055",
    "en": "REPUBLIC OF BENIN",
    "pt": "REP. POPULAR DO BENIM",
    "zh": "貝寧",
    "icao": "BEN"
  },
  {
    "code": "071",
    "en": "REPUBLIC OF GUINEA",
    "pt": "REPUBLICA DA GUINE",
    "zh": "幾內亞",
    "icao": "GIN"
  },
  {
    "code": "256",
    "en": "REPUBLIC OF KOREA",
    "pt": "REPUBLICA DA COREIA",
    "zh": "韓國",
    "icao": "KOR"
  },
  {
    "code": "039",
    "en": "REPUBLIC OF SAN MARINO",
    "pt": "REPUBLICA DE SAN MARINO",
    "zh": "聖馬力諾",
    "icao": "SMR"
  },
  {
    "code": "026",
    "en": "ROMANIA",
    "pt": "ROMENIA",
    "zh": "羅馬尼亞",
    "icao": "ROU"
  },
  {
    "code": "518",
    "en": "RUSSIA",
    "pt": "FEDERAÇÃO DA RUSSIA",
    "zh": "俄羅斯",
    "icao": "RUS"
  },
  {
    "code": "089",
    "en": "RWANDA",
    "pt": "RUANDA",
    "zh": "盧旺達",
    "icao": "RWA"
  },
  {
    "code": "225",
    "en": "SAINT LUCIA",
    "pt": "SANTA LUCIA",
    "zh": "聖盧西亞",
    "icao": "LCA"
  },
  {
    "code": "410",
    "en": "SAMOA",
    "pt": "SAMOA",
    "zh": "薩摩亞",
    "icao": "WSM"
  },
  {
    "code": "300",
    "en": "SAUDI ARABIA",
    "pt": "ARABIA SAUDITA",
    "zh": "沙特阿拉伯",
    "icao": "SAU"
  },
  {
    "code": "093",
    "en": "SENEGAL",
    "pt": "SENEGAL",
    "zh": "塞內加爾",
    "icao": "SEN"
  },
  {
    "code": "526",
    "en": "SERBIA",
    "pt": "REPUBLICA DA SERVIA",
    "zh": "塞爾維亞",
    "icao": "SRB"
  },
  {
    "code": "092",
    "en": "SEYCHELLES",
    "pt": "SEICHELES",
    "zh": "塞舌耳",
    "icao": "SYC"
  },
  {
    "code": "094",
    "en": "SIERRA LEONE",
    "pt": "SERRA LEOA",
    "zh": "塞拉利昂",
    "icao": "SLE"
  },
  {
    "code": "266",
    "en": "SINGAPORE",
    "pt": "SINGAPURA",
    "zh": "新加坡",
    "icao": "SGP"
  },
  {
    "code": "028",
    "en": "SLOVAKIA REPUBLIC",
    "pt": "REPUBLICA DA ESLOVACA",
    "zh": "斯洛伐克",
    "icao": "SVK"
  },
  {
    "code": "516",
    "en": "SLOVENIA",
    "pt": "REPUBLICA DA ESLOVÉNIA",
    "zh": "斯洛文尼亞",
    "icao": "SVN"
  },
  {
    "code": "414",
    "en": "SOLOMON ISLANDS",
    "pt": "ILHAS SALOMÃO",
    "zh": "所羅門群島",
    "icao": "SLB"
  },
  {
    "code": "095",
    "en": "SOMALIA",
    "pt": "SOMALIA",
    "zh": "索馬里",
    "icao": "SOM"
  },
  {
    "code": "051",
    "en": "SOUTH AFRICA",
    "pt": "AFRICA DO SUL",
    "zh": "南非",
    "icao": "ZAF"
  },
  {
    "code": "536",
    "en": "SOUTH SUDAN",
    "pt": "SUDÃO DO SUL",
    "zh": "南蘇丹",
    "icao": "SSD"
  },
  {
    "code": "031",
    "en": "SPAIN",
    "pt": "ESPANHA",
    "zh": "西班牙",
    "icao": "ESP"
  },
  {
    "code": "267",
    "en": "SRI LANKA",
    "pt": "SRI LANKA",
    "zh": "斯里蘭卡",
    "icao": "LKA"
  },
  {
    "code": "221",
    "en": "ST. CHRISTOPHER - NEVIS",
    "pt": "SÃO CRISTÓVÃO E NEVIS",
    "zh": "聖克里斯托弗和尼維斯",
    "icao": "KNA"
  },
  {
    "code": "091",
    "en": "ST. TOME AND PRINCIPE",
    "pt": "REP.DEM.S.TOME E PRINCIPE",
    "zh": "聖多美和普林西比",
    "icao": "STP"
  },
  {
    "code": "226",
    "en": "ST. VINCENT",
    "pt": "SÃO VICENTE",
    "zh": "聖文特島",
    "icao": "VCT"
  },
  {
    "code": "097",
    "en": "SUDAN",
    "pt": "SUDÃO",
    "zh": "蘇丹",
    "icao": "SDN"
  },
  {
    "code": "310",
    "en": "SULTANATE OF OMAN",
    "pt": "OMAN",
    "zh": "阿曼",
    "icao": "OMN"
  },
  {
    "code": "217",
    "en": "SURINAM",
    "pt": "SURINAME",
    "zh": "蘇里南",
    "icao": "SME"
  },
  {
    "code": "015",
    "en": "SWEDEN",
    "pt": "SUECIA",
    "zh": "瑞典",
    "icao": "SWE"
  },
  {
    "code": "016",
    "en": "SWITZERLAND",
    "pt": "SUIÇA",
    "zh": "瑞士",
    "icao": "CHE"
  },
  {
    "code": "312",
    "en": "SYRIA",
    "pt": "SIRIA",
    "zh": "敘利亞",
    "icao": "SYR"
  },
  {
    "code": "255",
    "en": "TAIWAN",
    "pt": "TERRITÓRIO DE TAIWAN",
    "zh": "台灣地區",
    "icao": "TWN"
  },
  {
    "code": "527",
    "en": "TAJIKISTAN",
    "pt": "REPUBLICA DO TADZIKISTÃO",
    "zh": "塔吉克斯坦",
    "icao": "TJK"
  },
  {
    "code": "098",
    "en": "TANZANIA",
    "pt": "TANZANIA",
    "zh": "坦桑尼亞",
    "icao": "TZA"
  },
  {
    "code": "268",
    "en": "THAILAND",
    "pt": "TAILANDIA",
    "zh": "泰國",
    "icao": "THA"
  },
  {
    "code": "303",
    "en": "THE UNITED ARAB EMIRATES",
    "pt": "EMIRADOS ARABES UNIDOS",
    "zh": "阿拉伯聯合酋長國",
    "icao": "ARE"
  },
  {
    "code": "101",
    "en": "TOGOLESE REPUBLIC",
    "pt": "REP.TOGOLESA",
    "zh": "多哥",
    "icao": "TGO"
  },
  {
    "code": "412",
    "en": "TONGA",
    "pt": "TONGA",
    "zh": "湯加",
    "icao": "TON"
  },
  {
    "code": "218",
    "en": "TRINIDAD AND TOBAGO",
    "pt": "TRINDADE E TOBAGO",
    "zh": "特立尼達和多巴哥",
    "icao": "TTO"
  },
  {
    "code": "102",
    "en": "TUNISIA",
    "pt": "TUNISIA",
    "zh": "突尼斯",
    "icao": "TUN"
  },
  {
    "code": "037",
    "en": "TURKEY",
    "pt": "TURQUIA",
    "zh": "土耳其",
    "icao": "TUR"
  },
  {
    "code": "528",
    "en": "TURKMENISTAN",
    "pt": "REPUBLICA DO TURKMENISTÃO",
    "zh": "土庫曼斯坦",
    "icao": "TKM"
  },
  {
    "code": "415",
    "en": "TUVALU",
    "pt": "TUVALU",
    "zh": "圖瓦魯",
    "icao": "TUV"
  },
  {
    "code": "103",
    "en": "UGANDA",
    "pt": "UGANDA",
    "zh": "烏干達",
    "icao": "UGA"
  },
  {
    "code": "517",
    "en": "UKRAINE",
    "pt": "REPUBLICA DA UCRANIA",
    "zh": "烏克蘭",
    "icao": "UKR"
  },
  {
    "code": "508",
    "en": "UNITED KINGDOM",
    "pt": "REINO UNIDO",
    "zh": "英國",
    "icao": "GBR"
  },
  {
    "code": "209",
    "en": "USA",
    "pt": "ESTADOS UNIDOS DA AMERICA",
    "zh": "美國",
    "icao": "USA"
  },
  {
    "code": "169",
    "en": "URUGUAY",
    "pt": "URUGUAI",
    "zh": "烏拉圭",
    "icao": "URY"
  },
  {
    "code": "519",
    "en": "UZBEKISTAN",
    "pt": "REPUBLICA DO UZBEQUISTÃO",
    "zh": "烏茲別克斯坦",
    "icao": "UZB"
  },
  {
    "code": "418",
    "en": "VANUATU",
    "pt": "VANUATU",
    "zh": "瓦努阿圖",
    "icao": "VUT"
  },
  {
    "code": "170",
    "en": "VENEZUELA",
    "pt": "VENEZUELA",
    "zh": "委內瑞拉",
    "icao": "VEN"
  },
  {
    "code": "353",
    "en": "VIETNAM",
    "pt": "REP. SOC. DO VIETNAM",
    "zh": "越南",
    "icao": "VNM"
  },
  {
    "code": "313",
    "en": "YEMEN",
    "pt": "IÉMEN",
    "zh": "也門",
    "icao": "YEM"
  },
  {
    "code": "105",
    "en": "ZAMBIA",
    "pt": "ZAMBIA",
    "zh": "贊比亞",
    "icao": "ZMB"
  },
  {
    "code": "088",
    "en": "ZIMBABWE",
    "pt": "REP. DO ZIMBABWE",
    "zh": "津巴布韋",
    "icao": "ZWE"
  },
  {
    "code": "350",
    "en": "CHINA",
    "pt": "REP. POPULAR DA CHINA",
    "zh": "中國",
    "icao": "CHN"
  }
]

const excludeList = ["350", "258"]

const result = countriesData.filter(x => !excludeList.includes(x.code))

export default result;